import React, {useEffect, useState} from 'react';
import {withTranslation} from "react-i18next";
import Layout from "../../layout/Layout";
import {getData} from "../../helpers/utils";

const Services = ({t}) => {


    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const result = await getData();
            setData(result);
            setLoading(false);
        };

        fetchData();
    }, []);

    return (
        <Layout pageName="Services">

        </Layout>
    )
}

export default withTranslation()(Services)